/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { forwardRef, useImperativeHandle, useState } from "react";
import toast from "react-hot-toast";
import validator from "validator";
import Button from "@mui/material/Button";
import InputFileUpload from "./InputFile";
import { find } from "lodash";
const AntecedentesPrenatales = forwardRef(
  ({ Back, Next, props, vista = "registrar", desactivar }, ref) => {
    const [txtEdadGestacional, settxtEdadGestacional] = useState(
      props?.edadGestacional ? props.edadGestacional : ""
    );
    const [isvalid_txtEdadGestacional, isvalid_settxtEdadGestacional] = useState(false);

    const [cboTipoParto, setcboTipoParto] = useState(props?.idTipoParto ?? null);
    const [isvalid_cboTipoParto, isvalid_setcboTipoParto] = useState(false);

    const [txtPesoNacimiento, settxtPesoNacimiento] = useState(
      props?.pesoNacimiento ? props.pesoNacimiento : ""
    );
    const [isvalid_txtPesoNacimiento, isvalid_settxtPesoNacimiento] = useState(false);

    const [txtTallaNacimiento, settxtTallaNacimiento] = useState(
      props?.tallaNacimiento ? props.tallaNacimiento : ""
    );
    const [isvalid_txtTallaNacimiento, isvalid_settxtTallaNacimiento] = useState(false);

    const [cboAPGAR1, setcboAPGAR1] = useState(props?.apgaR1 ?? null);
    const [isvalid_cboAPGAR1, isvalid_settcboAPGAR1] = useState(false);

    const [cboAPGAR2, setcboAPGAR2] = useState(props?.apgaR2 ?? null);
    const [isvalid_cboAPGAR2, isvalid_settcboAPGAR2] = useState(false);

    const [cboTerapiaIntensiva, setcboTerapiaIntensiva] = useState(props?.terapiaIntensiva ?? null);
    const [isvalid_cboTerapiaIntensiva, isvalid_setcboTerapiaIntensiva] = useState(false);

    const [txtMotivoTerapiaIntensiva, settxtMotivoTerapiaIntensiva] = useState(
      props?.motivoTerapiaIntensiva ? props.motivoTerapiaIntensiva : ""
    );
    const [isvalid_txtMotivoTerapiaIntensiva, isvalid_settxtMotivoTerapiaIntensiva] =
      useState(false);

    const [cboDadoAltaConMadre, setcboDadoAltaConMadre] = useState(props?.dadoAltaConMadre ?? null);
    const [isvalid_cboDadoAltaConMadre, isvalid_setcboDadoAltaConMadre] = useState(false);

    const [cboPadecioIctericia, setcboPadecioIctericia] = useState(props?.padecioIctericia ?? null);
    const [isvalid_cboPadecioIctericia, isvalid_setcboPadecioIctericia] = useState(false);

    const [cboInfeccionEmbarazo, setcboInfeccionEmbarazo] = useState(
      props?.infeccionEmbarazo ?? null
    );
    const [isvalid_cboInfeccionEmbarazo, isvalid_setcboInfeccionEmbarazo] = useState(false);

    const [txtInfeccionEmbarazo, settxtInfeccionEmbarazo] = useState(
      props?.especifiqueInfeccion ? props.especifiqueInfeccion : ""
    );
    const [isvalid_txtInfeccionEmbarazo, isvalid_settxtInfeccionEmbarazo] = useState(false);

    const [txtResEstudioTorch, settxtResEstudioTorch] = useState(
      props?.resEstudioTorch ? props.resEstudioTorch : ""
    );
    const [fileEstudioTorch, setfileEstudioTorch] = useState(
      props?.fileEstudioTorch ? props.fileEstudioTorch : null
    );

    const apgar = [
      {
        label: "N/A",
        value: "0",
      },
      {
        label: "1",
        value: "1",
      },
      {
        label: "2",
        value: "2",
      },
      {
        label: "3",
        value: "3",
      },
      {
        label: "4",
        value: "4",
      },
      {
        label: "5",
        value: "5",
      },
      {
        label: "6",
        value: "6",
      },
      {
        label: "7",
        value: "7",
      },
      {
        label: "8",
        value: "8",
      },
      {
        label: "9",
        value: "9",
      },
      {
        label: "10",
        value: "10",
      },
    ];

    const ValidaForm = () => {
      if (!txtEdadGestacional) {
        toast.error("Campo Obligatorio *");
        isvalid_settxtEdadGestacional(true);
        return null;
      }
      if (!cboTipoParto) {
        toast.error("Campo Obligatorio *");
        isvalid_setcboTipoParto(true);
        return null;
      }

      if (!txtPesoNacimiento) {
        toast.error("Campo Obligatorio *");
        isvalid_settxtPesoNacimiento(true);
        return null;
      }

      if (!txtTallaNacimiento) {
        toast.error("Campo Obligatorio *");
        isvalid_settxtTallaNacimiento(true);
        return null;
      }

      if (cboAPGAR1 == null) {
        toast.error("Campo Obligatorio *");
        isvalid_settcboAPGAR1(true);
        return null;
      }
      if (cboAPGAR2 == null) {
        toast.error("Campo Obligatorio *");
        isvalid_settcboAPGAR2(true);
        return null;
      }
      if (cboTerapiaIntensiva == null || cboTerapiaIntensiva == undefined) {
        toast.error("Campo Obligatorio *");
        isvalid_setcboTerapiaIntensiva(true);
        return null;
      }
      if (cboTerapiaIntensiva == "1" && !txtMotivoTerapiaIntensiva) {
        toast.error("Campo Obligatorio *");
        isvalid_settxtMotivoTerapiaIntensiva(true);
        return null;
      }
      if (cboDadoAltaConMadre == null || cboDadoAltaConMadre == undefined) {
        toast.error("Campo Obligatorio *");
        isvalid_setcboDadoAltaConMadre(true);
        return null;
      }
      if (cboPadecioIctericia == null || cboPadecioIctericia == undefined) {
        toast.error("Campo Obligatorio *");
        isvalid_setcboPadecioIctericia(true);
        return null;
      }
      if (cboInfeccionEmbarazo == null || cboInfeccionEmbarazo == undefined) {
        toast.error("Campo Obligatorio *");
        isvalid_setcboInfeccionEmbarazo(true);
        return null;
      }
      if (cboInfeccionEmbarazo == "1" && !txtInfeccionEmbarazo) {
        toast.error("Campo Obligatorio *");
        isvalid_settxtInfeccionEmbarazo(true);
        return null;
      }
      var data = {
        edadGestacional: txtEdadGestacional,
        idTipoParto: cboTipoParto,
        pesoNacimiento: txtPesoNacimiento,
        tallaNacimiento: txtTallaNacimiento,
        apgaR1: cboAPGAR1,
        apgaR2: cboAPGAR2,
        terapiaIntensiva: cboTerapiaIntensiva,
        motivoTerapiaIntensiva: txtMotivoTerapiaIntensiva,
        dadoAltaConMadre: cboDadoAltaConMadre,
        padecioIctericia: cboPadecioIctericia,
        infeccionEmbarazo: cboInfeccionEmbarazo,
        especifiqueInfeccion: txtInfeccionEmbarazo,
        resEstudioTorch: txtResEstudioTorch,
        fileEstudioTorch: fileEstudioTorch,
      };
      var data2 = [
        {
          titulo: "Estudio TORCH",
          file: fileEstudioTorch,
        },
      ];
      Next(data, data2);
      return data;
    };

    //Métodos para guardar los datos editados:
    useImperativeHandle(ref, () => ({
      ejecutarNext: () => {
        return ValidaForm();
      },
    }));

    const handleBack = () => {
      var data = {
        edadGestacional: txtEdadGestacional,
        idTipoParto: cboTipoParto,
        pesoNacimiento: txtPesoNacimiento,
        tallaNacimiento: txtTallaNacimiento,
        apgaR1: cboAPGAR1,
        apgaR2: cboAPGAR2,
        terapiaIntensiva: cboTerapiaIntensiva,
        motivoTerapiaIntensiva: txtMotivoTerapiaIntensiva,
        dadoAltaConMadre: cboDadoAltaConMadre,
        padecioIctericia: cboPadecioIctericia,
        infeccionEmbarazo: cboInfeccionEmbarazo,
        especifiqueInfeccion: txtInfeccionEmbarazo,
        resEstudioTorch: txtResEstudioTorch,
        fileEstudioTorch: fileEstudioTorch,
      };

      Back(data);
    };

    return (
      <>
        <Grid container spacing={4}>
          {/* Primera columna: Label y input de Edad Gestacional */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Edad gestacional (semanas):
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <TextField
              label="Edad"
              value={txtEdadGestacional}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  settxtEdadGestacional(value);
                }
              }}
              error={isvalid_txtEdadGestacional}
              helperText={isvalid_txtEdadGestacional ? "Campo obligatorio *" : ""}
              disabled={desactivar}
              onFocus={() => {
                isvalid_settxtEdadGestacional(false);
              }}
              onBlur={() => {
                if (!txtEdadGestacional) isvalid_settxtEdadGestacional(true);
              }}
              variant="outlined"
              size="small"
              inputProps={{
                inputMode: "numeric", // Muestra teclado numérico en móviles
                pattern: "[0-9]*", // Sugiere sólo números
              }}
              fullWidth
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* Segunda columna: Label y ComboBox para Tipo de Parto */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Producto de:
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <Autocomplete
              options={[
                { label: "Parto natural", value: "1" },
                { label: "Cesárea", value: "2" },
              ]}
              getOptionLabel={(option) => option.label}
              disabled={desactivar}
              value={
                [
                  { label: "Parto natural", value: "1" },
                  { label: "Cesárea", value: "2" },
                ].find((opt) => opt.value == cboTipoParto) || null
              }
              onChange={(event, newValue) => setcboTipoParto(newValue ? newValue.value : null)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Seleccione tipo de parto"
                  variant="outlined"
                  autoComplete="new-password"
                  error={isvalid_cboTipoParto}
                  helperText={isvalid_cboTipoParto ? "Campo obligatorio *" : ""}
                  disabled={desactivar}
                  onFocus={() => {
                    isvalid_setcboTipoParto(false);
                    if (!txtEdadGestacional) {
                      isvalid_settxtEdadGestacional(true);
                    }
                  }}
                  onBlur={() => {
                    if (!cboTipoParto) isvalid_setcboTipoParto(true);
                  }}
                  fullWidth
                />
              )}
              size="small"
            />
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={4}>
          {/* Primera columna: Label y input de Peso al nacer */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Peso al nacer (kg):
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <TextField
              label="Peso"
              autoComplete="off"
              value={txtPesoNacimiento}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d*$/.test(value)) {
                  settxtPesoNacimiento(value);
                }
              }}
              variant="outlined"
              disabled={desactivar}
              fullWidth
              size="small"
              error={isvalid_txtPesoNacimiento}
              helperText={isvalid_txtPesoNacimiento ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_settxtPesoNacimiento(false);
                if (!txtEdadGestacional) {
                  isvalid_settxtEdadGestacional(true);
                }
                if (!cboTipoParto) {
                  isvalid_setcboTipoParto(true);
                }
              }}
              onBlur={() => {
                if (!txtPesoNacimiento) isvalid_settxtPesoNacimiento(true);
              }}
              inputProps={{
                inputMode: "numeric", // Muestra teclado numérico en móviles
                pattern: "[0-9]+(\\.[0-9]+)?", // solo punto como decimal
              }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          {/* Segunda columna: Label y input de Talla */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Talla (cm):
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <TextField
              label="Talla"
              autoComplete="off"
              value={txtTallaNacimiento}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  settxtTallaNacimiento(value);
                }
              }}
              variant="outlined"
              disabled={desactivar}
              fullWidth
              size="small"
              error={isvalid_txtTallaNacimiento}
              helperText={isvalid_txtTallaNacimiento ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_settxtTallaNacimiento(false);
                if (!txtEdadGestacional) {
                  isvalid_settxtEdadGestacional(true);
                }
                if (!cboTipoParto) {
                  isvalid_setcboTipoParto(true);
                }
                if (!txtPesoNacimiento) {
                  isvalid_settxtPesoNacimiento(true);
                }
              }}
              onBlur={() => {
                if (!txtTallaNacimiento) isvalid_settxtTallaNacimiento(true);
              }}
              inputProps={{
                inputMode: "numeric", // Muestra teclado numérico en móviles
                pattern: "[0-9]*", // Sugiere sólo números
              }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={2}>
          {/* Primera columna: Label de APGAR */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                APGAR:
              </MDTypography>
            </MDBox>
          </Grid>

          {/* Segunda columna: ComboBox para C1 */}
          <Grid item xs={12} md={3} lg={3}>
            <Autocomplete
              options={apgar}
              getOptionLabel={(option) => option.label}
              disabled={desactivar}
              value={apgar.find((opt) => opt.value == cboAPGAR1) || null}
              onChange={(event, newValue) => {
                setcboAPGAR1(newValue ? newValue.value : null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="C1"
                  variant="outlined"
                  autoComplete="new-password"
                  disabled={desactivar}
                  fullWidth
                  error={isvalid_cboAPGAR1}
                  helperText={isvalid_cboAPGAR1 ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settcboAPGAR1(false);
                    if (!txtEdadGestacional) {
                      isvalid_settxtEdadGestacional(true);
                    }
                    if (!cboTipoParto) {
                      isvalid_setcboTipoParto(true);
                    }
                    if (!txtPesoNacimiento) {
                      isvalid_settxtPesoNacimiento(true);
                    }
                    if (!txtTallaNacimiento) {
                      isvalid_settxtTallaNacimiento(true);
                    }
                  }}
                  onBlur={() => {
                    if (cboAPGAR1 == null || cboAPGAR1 == undefined) isvalid_settcboAPGAR1(true);
                  }}
                />
              )}
              size="small"
            />
          </Grid>

          <Grid item xs={12} md={3} lg={3}></Grid>
          {/* Tercera columna: ComboBox para C2 */}
          <Grid item xs={12} md={3} lg={3}>
            <Autocomplete
              options={apgar}
              getOptionLabel={(option) => option.label}
              disabled={desactivar}
              value={apgar.find((opt) => opt.value == cboAPGAR2) || null}
              onChange={(event, newValue) => {
                setcboAPGAR2(newValue ? newValue.value : null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="C2"
                  variant="outlined"
                  autoComplete="new-password"
                  disabled={desactivar}
                  fullWidth
                  error={isvalid_cboAPGAR2}
                  helperText={isvalid_cboAPGAR2 ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_settcboAPGAR2(false);
                    if (!txtEdadGestacional) {
                      isvalid_settxtEdadGestacional(true);
                    }
                    if (!cboTipoParto) {
                      isvalid_setcboTipoParto(true);
                    }
                    if (!txtPesoNacimiento) {
                      isvalid_settxtPesoNacimiento(true);
                    }
                    if (!txtTallaNacimiento) {
                      isvalid_settxtTallaNacimiento(true);
                    }
                    if (cboAPGAR1 == null) {
                      isvalid_settcboAPGAR1(true);
                    }
                  }}
                  onBlur={() => {
                    if (cboAPGAR2 == null || cboAPGAR2 == undefined) isvalid_settcboAPGAR2(true);
                  }}
                />
              )}
              size="small"
            />
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={2}>
          {/* Primera columna: Label y ComboBox para Terapia Intensiva */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha estado en terapia intensiva?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <Autocomplete
              options={[
                { label: "Sí", value: "1" },
                { label: "No", value: "0" },
              ]}
              getOptionLabel={(option) => option.label}
              disabled={desactivar}
              value={
                [
                  { label: "Sí", value: "1" },
                  { label: "No", value: "0" },
                ].find((opt) => opt.value == cboTerapiaIntensiva) || null
              }
              onChange={(event, newValue) => {
                setcboTerapiaIntensiva(newValue ? newValue.value : null);
                if (newValue != null && newValue.value == "1") {
                  isvalid_settxtMotivoTerapiaIntensiva(true);
                } else {
                  isvalid_settxtMotivoTerapiaIntensiva(false);
                  settxtMotivoTerapiaIntensiva("");
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Seleccione"
                  variant="outlined"
                  autoComplete="new-password"
                  disabled={desactivar}
                  fullWidth
                  error={isvalid_cboTerapiaIntensiva}
                  helperText={isvalid_cboTerapiaIntensiva ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setcboTerapiaIntensiva(false);
                    if (!txtEdadGestacional) {
                      isvalid_settxtEdadGestacional(true);
                    }
                    if (!cboTipoParto) {
                      isvalid_setcboTipoParto(true);
                    }
                    if (!txtPesoNacimiento) {
                      isvalid_settxtPesoNacimiento(true);
                    }
                    if (!txtTallaNacimiento) {
                      isvalid_settxtTallaNacimiento(true);
                    }
                    if (cboAPGAR1 == null) {
                      isvalid_settcboAPGAR1(true);
                    }
                    if (cboAPGAR2 == null) {
                      isvalid_settcboAPGAR2(true);
                    }
                  }}
                  onBlur={() => {
                    if (cboTerapiaIntensiva == null) isvalid_setcboTerapiaIntensiva(true);
                  }}
                />
              )}
              size="small"
            />
          </Grid>
          {/* Segunda columna: Label y input para Motivo/Duración de la estancia */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Motivo/Duración de la estancia (días):
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <TextField
              type="text"
              value={txtMotivoTerapiaIntensiva}
              error={isvalid_txtMotivoTerapiaIntensiva}
              helperText={isvalid_txtMotivoTerapiaIntensiva ? "Campo obligatorio *" : ""}
              onChange={(e) => {
                if (cboTerapiaIntensiva != null && cboTerapiaIntensiva == "1") {
                  settxtMotivoTerapiaIntensiva(e.target.value);
                }
              }}
              onFocus={() => {
                isvalid_settxtMotivoTerapiaIntensiva(false);
                if (!txtEdadGestacional) {
                  isvalid_settxtEdadGestacional(true);
                }
                if (!cboTipoParto) {
                  isvalid_setcboTipoParto(true);
                }
                if (!txtPesoNacimiento) {
                  isvalid_settxtPesoNacimiento(true);
                }
                if (!txtTallaNacimiento) {
                  isvalid_settxtTallaNacimiento(true);
                }
                if (cboAPGAR1 == null) {
                  isvalid_settcboAPGAR1(true);
                }
                if (cboAPGAR2 == null) {
                  isvalid_settcboAPGAR2(true);
                }
                if (cboTerapiaIntensiva == null) {
                  isvalid_setcboTerapiaIntensiva(true);
                }
              }}
              onBlur={() => {
                if (
                  !txtMotivoTerapiaIntensiva &&
                  cboTerapiaIntensiva != null &&
                  cboTerapiaIntensiva.value == "1"
                ) {
                  isvalid_settxtMotivoTerapiaIntensiva(true);
                }
              }}
              variant="outlined"
              disabled={desactivar}
              fullWidth
              size="small"
              autoComplete="off"
            />
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={2}>
          {/* Primera columna: Label y ComboBox para Dado de alta con la madre */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Dado de alta con la madre?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <Autocomplete
              options={[
                { label: "Sí", value: "1" },
                { label: "No", value: "0" },
              ]}
              getOptionLabel={(option) => option.label}
              disabled={desactivar}
              value={
                [
                  { label: "Sí", value: "1" },
                  { label: "No", value: "0" },
                ].find((opt) => opt.value == cboDadoAltaConMadre) || null
              }
              onChange={(event, newValue) =>
                setcboDadoAltaConMadre(newValue ? newValue.value : null)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Seleccione"
                  variant="outlined"
                  autoComplete="new-password"
                  disabled={desactivar}
                  fullWidth
                  error={isvalid_cboDadoAltaConMadre}
                  helperText={isvalid_cboDadoAltaConMadre ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setcboDadoAltaConMadre(false);
                    if (!txtEdadGestacional) {
                      isvalid_settxtEdadGestacional(true);
                    }
                    if (!cboTipoParto) {
                      isvalid_setcboTipoParto(true);
                    }
                    if (!txtPesoNacimiento) {
                      isvalid_settxtPesoNacimiento(true);
                    }
                    if (!txtTallaNacimiento) {
                      isvalid_settxtTallaNacimiento(true);
                    }
                    if (cboAPGAR1 == null) {
                      isvalid_settcboAPGAR1(true);
                    }
                    if (cboAPGAR2 == null) {
                      isvalid_settcboAPGAR2(true);
                    }
                    if (cboTerapiaIntensiva == null) {
                      isvalid_setcboTerapiaIntensiva(true);
                    }
                    if (!txtMotivoTerapiaIntensiva && cboTerapiaIntensiva == 1) {
                      isvalid_settxtMotivoTerapiaIntensiva(true);
                    }
                  }}
                  onBlur={() => {
                    if (cboDadoAltaConMadre == null) isvalid_setcboDadoAltaConMadre(true);
                  }}
                />
              )}
              size="small"
            />
          </Grid>
          {/* Segunda columna: Label y ComboBox para Padeció ictericia */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Padeció ictericia?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <Autocomplete
              options={[
                { label: "Sí", value: "1" },
                { label: "No", value: "0" },
              ]}
              getOptionLabel={(option) => option.label}
              disabled={desactivar}
              value={
                [
                  { label: "Sí", value: "1" },
                  { label: "No", value: "0" },
                ].find((opt) => opt.value == cboPadecioIctericia) || null
              }
              onChange={(event, newValue) =>
                setcboPadecioIctericia(newValue ? newValue.value : null)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Seleccione"
                  variant="outlined"
                  autoComplete="new-password"
                  disabled={desactivar}
                  fullWidth
                  error={isvalid_cboPadecioIctericia}
                  helperText={isvalid_cboPadecioIctericia ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setcboPadecioIctericia(false);
                    if (!txtEdadGestacional) {
                      isvalid_settxtEdadGestacional(true);
                    }
                    if (!cboTipoParto) {
                      isvalid_setcboTipoParto(true);
                    }
                    if (!txtPesoNacimiento) {
                      isvalid_settxtPesoNacimiento(true);
                    }
                    if (!txtTallaNacimiento) {
                      isvalid_settxtTallaNacimiento(true);
                    }
                    if (cboAPGAR1 == null) {
                      isvalid_settcboAPGAR1(true);
                    }
                    if (cboAPGAR2 == null) {
                      isvalid_settcboAPGAR2(true);
                    }
                    if (cboTerapiaIntensiva == null) {
                      isvalid_setcboTerapiaIntensiva(true);
                    }
                    if (!txtMotivoTerapiaIntensiva && cboTerapiaIntensiva == 1) {
                      isvalid_settxtMotivoTerapiaIntensiva(true);
                    }
                    if (cboDadoAltaConMadre == null) {
                      isvalid_setcboDadoAltaConMadre(true);
                    }
                  }}
                  onBlur={() => {
                    if (cboPadecioIctericia == null) isvalid_setcboPadecioIctericia(true);
                  }}
                />
              )}
              size="small"
            />
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={2}>
          {/* Primera columna: Label y ComboBox para infección en el embarazo */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Alguna infección importante durante el embarazo?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <Autocomplete
              options={[
                { label: "Sí", value: "1" },
                { label: "No", value: "0" },
              ]}
              getOptionLabel={(option) => option.label}
              disabled={desactivar}
              value={
                [
                  { label: "Sí", value: "1" },
                  { label: "No", value: "0" },
                ].find((opt) => opt.value == cboInfeccionEmbarazo) || null
              }
              onChange={(event, newValue) => {
                setcboInfeccionEmbarazo(newValue ? newValue.value : null);
                if (newValue != null && newValue.value == "1") {
                  isvalid_settxtInfeccionEmbarazo(true);
                } else {
                  isvalid_settxtInfeccionEmbarazo(false);
                  settxtInfeccionEmbarazo("");
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Seleccione"
                  variant="outlined"
                  autoComplete="new-password"
                  disabled={desactivar}
                  fullWidth
                  error={isvalid_cboInfeccionEmbarazo}
                  helperText={isvalid_cboInfeccionEmbarazo ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setcboInfeccionEmbarazo(false);
                    if (!txtEdadGestacional) {
                      isvalid_settxtEdadGestacional(true);
                    }
                    if (!cboTipoParto) {
                      isvalid_setcboTipoParto(true);
                    }
                    if (!txtPesoNacimiento) {
                      isvalid_settxtPesoNacimiento(true);
                    }
                    if (!txtTallaNacimiento) {
                      isvalid_settxtTallaNacimiento(true);
                    }
                    if (cboAPGAR1 == null) {
                      isvalid_settcboAPGAR1(true);
                    }
                    if (cboAPGAR2 == null) {
                      isvalid_settcboAPGAR2(true);
                    }
                    if (cboTerapiaIntensiva == null) {
                      isvalid_setcboTerapiaIntensiva(true);
                    }
                    if (!txtMotivoTerapiaIntensiva && cboTerapiaIntensiva == 1) {
                      isvalid_settxtMotivoTerapiaIntensiva(true);
                    }
                    if (cboDadoAltaConMadre == null) {
                      isvalid_setcboDadoAltaConMadre(true);
                    }
                    if (cboPadecioIctericia == null) {
                      isvalid_setcboPadecioIctericia(true);
                    }
                  }}
                  onBlur={() => {
                    if (cboInfeccionEmbarazo == null) isvalid_setcboInfeccionEmbarazo(true);
                  }}
                />
              )}
              size="small"
            />
          </Grid>
          {/* Segunda columna: Label y input para especificar infección */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Especifique:
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <TextField
              type="text"
              disabled={desactivar}
              value={txtInfeccionEmbarazo}
              error={isvalid_txtInfeccionEmbarazo}
              helperText={isvalid_txtInfeccionEmbarazo ? "Campo obligatorio *" : ""}
              onChange={(e) => {
                if (cboInfeccionEmbarazo != null && cboInfeccionEmbarazo == "1") {
                  ("entra");
                  settxtInfeccionEmbarazo(e.target.value);
                }
              }}
              onFocus={() => {
                isvalid_settxtInfeccionEmbarazo(false);
                if (!txtEdadGestacional) {
                  isvalid_settxtEdadGestacional(true);
                }
                if (!cboTipoParto) {
                  isvalid_setcboTipoParto;
                }
                if (!txtPesoNacimiento) {
                  isvalid_settxtPesoNacimiento(true);
                }
                if (!txtTallaNacimiento) {
                  isvalid_settxtTallaNacimiento(true);
                }
                if (cboAPGAR1 == null) {
                  isvalid_settcboAPGAR1(true);
                }
                if (cboAPGAR2 == null) {
                  isvalid_settcboAPGAR2(true);
                }
                if (cboTerapiaIntensiva == null) {
                  isvalid_setcboTerapiaIntensiva(true);
                }
                if (!txtMotivoTerapiaIntensiva && cboTerapiaIntensiva == 1) {
                  isvalid_settxtMotivoTerapiaIntensiva(true);
                }
                if (cboDadoAltaConMadre == null) {
                  isvalid_setcboDadoAltaConMadre(true);
                }
                if (cboPadecioIctericia == null) {
                  isvalid_setcboPadecioIctericia(true);
                }
                if (cboInfeccionEmbarazo == null) {
                  isvalid_setcboInfeccionEmbarazo(true);
                }
              }}
              onBlur={() => {
                if (
                  !txtInfeccionEmbarazo &&
                  cboInfeccionEmbarazo != null &&
                  cboInfeccionEmbarazo.value == "1"
                ) {
                  isvalid_settxtInfeccionEmbarazo(true);
                }
              }}
              variant="outlined"
              fullWidth
              size="small"
              autoComplete="off"
            />
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={2}>
          {/* Primera columna: Label y ComboBox para infección en el embarazo */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                {
                  "Resultado Estudio Torch: (Realizado a la madre durante el primer trimestre del embarazo)"
                }
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              type="text"
              disabled={desactivar}
              value={txtResEstudioTorch}
              onChange={(e) => settxtResEstudioTorch(e.target.value)}
              onFocus={() => {
                if (!txtEdadGestacional) {
                  isvalid_settxtEdadGestacional(true);
                }
                if (!cboTipoParto) {
                  isvalid_setcboTipoParto(true);
                }
                if (!txtPesoNacimiento) {
                  isvalid_settxtPesoNacimiento(true);
                }
                if (!txtTallaNacimiento) {
                  isvalid_settxtTallaNacimiento(true);
                }
                if (cboAPGAR1 == null) {
                  isvalid_settcboAPGAR1(true);
                }
                if (cboAPGAR2 == null) {
                  isvalid_settcboAPGAR2(true);
                }
                if (cboTerapiaIntensiva == null) {
                  isvalid_setcboTerapiaIntensiva(true);
                }
                if (!txtMotivoTerapiaIntensiva && cboTerapiaIntensiva == 1) {
                  isvalid_settxtMotivoTerapiaIntensiva(true);
                }
                if (cboDadoAltaConMadre == null) {
                  isvalid_setcboDadoAltaConMadre(true);
                }
                if (cboPadecioIctericia == null) {
                  isvalid_setcboPadecioIctericia(true);
                }
                if (cboInfeccionEmbarazo == null) {
                  isvalid_setcboInfeccionEmbarazo(true);
                }
                if (!txtInfeccionEmbarazo && cboInfeccionEmbarazo == 1) {
                  isvalid_settxtInfeccionEmbarazo(true);
                }
              }}
              variant="outlined"
              fullWidth
              size="small"
              multiline={true}
              rows={5}
              autoComplete="off"
            />
          </Grid>
        </Grid>

        <br />
        {vista == "visualizar" ? null : (
          <Grid container spacing={2}>
            {/* Primera columna vacía (sin label) */}
            <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography
                  variant="h6"
                  color="white"
                  style={{ opacity: 0.7, fontSize: "0.9rem" }}
                >
                  Subir Estudio:
                </MDTypography>
              </MDBox>
            </Grid>

            {/* Segunda columna: Texto "Subir Estudio" y input tipo file */}
            <Grid item xs={12} md={9} lg={9}>
              <InputFileUpload
                onchangeFile={(file) => setfileEstudioTorch(file)}
                valueF={fileEstudioTorch}
              />
            </Grid>
          </Grid>
        )}
        {vista == "visualizar" ? null : (
          <MDBox textAlign="right">
            <Button
              variant="contained"
              onClick={() => ValidaForm()}
              sx={{ mt: 1, mr: 1 }}
              size="small"
              color="primary"
            >
              {"Continuar"}
            </Button>
            <Button
              variant="contained"
              disabled={false}
              onClick={() => handleBack()}
              sx={{ mt: 1, mr: 1 }}
              color="secondary"
              size="small"
            >
              Volver
            </Button>
          </MDBox>
        )}
      </>
    );
  }
);
export default AntecedentesPrenatales;
